<template>
  <b-modal
    id="modal-workplace-blocked"
    ref="workplaceBlockedModal"
    :title="workplaceBlocked.workplace_name ? `Bloquear Lançamento (${workplaceBlocked.workplace_name})` : ''"
    hide-footer
    size="sm"
    centered
    no-close-on-backdrop
  >
    <div class="d-flex w-100">
      <div class="mr-2">
        <div class="-mr-2 blocked-at">
          <label>Informe a data</label>
          <flat-pickr
            v-model="workplaceBlocked.blocked_at"
            class="form-control input-date"
            :config="configDate"
            :class="{'is-invalid': false }"
          />
        </div>
      </div>
    </div>
    <div class="text-right">
      <b-button
        variant="primary"
        class="mt-2"
        :disabled="loading"
        @click="blockRelease"
      >
        <span class="d-none d-sm-inline">Bloquear</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal, VBModal } from 'bootstrap-vue'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import flatPickr from 'vue-flatpickr-component'
import useWorkplaceBlocked from './useWorkplaceBlocked'

export default {
  components: {
    BButton,
    BModal,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      configDate: {
        enableTime: true,
        altInput: true,
        altFormat: 'd/m/Y H:i',
        dateFormat: 'Y-m-d H:i:S',
        locale: Portuguese,
        time_24hr: true,
      },
    }
  },
  setup(_, { emit }) {
    const {
      loading,
      workplaceBlockedModal,
      workplaceBlocked,
      show,
      blockRelease,
    } = useWorkplaceBlocked(() => emit('refetch-data'))

    return {
      loading,
      workplaceBlockedModal,
      workplaceBlocked,
      show,
      blockRelease,
    }
  },
}
</script>
